module.exports = __webpack_public_path__ + "media/images/vp/icon.delete.outline.black-fa3c35a43dfd23cf9ad4d2e6513ea541.svg";